import React from "react";
import { connect } from "react-redux";
import TextField from "material-ui/TextField";
import { Card, CardHeader, CardActions, CardText } from "material-ui/Card";
import ListItem from "material-ui/List/ListItem";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import { createOption, updateOption, deleteOption } from "../actions/option";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import IconButton from "material-ui/IconButton/IconButton";
import { withRouter } from "react-router";
import { Tabs, Tab } from "material-ui/Tabs";
import CategorizedQuestionList from "./CategorizedQuestionList";
import CaveatListEditor from "./CaveatListEditor";
import AdditionalCaveatsEditor from "../components/AdditionalCaveatsEditor";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { uploadImage } from "../actions/sync";
import htmlToDraft from "html-to-draftjs";
import Select from "react-select";
import CategorizedItemList from "./CategorizedItemList";
import CriteriaDialog from "./CriteriaDialog";
import {adminCardStyle} from '../containers/AdminHomepage';
import {assessmentTiers} from "./resultItems/AssessmentTier";

let editorStyle = {
  height: 400,
  padding: 10
};

let toolbarStyle = {
  width: "100%",
  padding: "10px 0",
  border: "none",
  borderBottom: "1px solid #efefef"
};

export const toEditorState = html => {
  html = html || "";
  if (html === "" || !html) {
    const contentState = ContentState.createFromText("");
    return EditorState.createWithContent(contentState);
  } else {
    var blocksFromHTML;
    var contentBlocks;
    try {
      blocksFromHTML = htmlToDraft(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    } catch (e) {
      blocksFromHTML = convertFromHTML(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    }
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    return EditorState.createWithContent(contentState);
  }
};

const toHtml = editorState => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
};

class OptionForm extends React.Component {
  constructor(props) {
    super();
    this.state = {
      title: "Option Title",
      section: "monitoring",
      ...props.option,
      categoryErrorText: "",
      titleErrorText: "",
      inputCatErrorText: "",
      assessmentTierErrorText: "",
      descriptionState: toEditorState(
        props.option ? props.option.description : ""
      ),
      assessmentOutputState: toEditorState(
        props.option ? props.option.assessmentOutput : ""
      ),
      contactsState: toEditorState(props.option ? props.option.contacts : ""),
      referencesState: toEditorState(
        props.option ? props.option.references : ""
      ),
      criteria: {},
      criteriaDialogOpen: false,
    };
    this.delete = this.delete.bind(this);
    this.checkTitle = this.checkTitle.bind(this);
    this.checkCategory = this.checkCategory.bind(this);
    this.showCategoryIndicatorTest = this.showCategoryIndicatorTest.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleAssessmentOutputChange = this.handleAssessmentOutputChange.bind(
      this
    );
    this.handleContactsChange = this.handleContactsChange.bind(this);
    this.handleReferencesChange = this.handleReferencesChange.bind(this);
    this.checkAssessmentTier = this.checkAssessmentTier.bind(this);
  }

  // This shortcuts are needed because the db expects an array of ids,
  // but react-select needs objects with a value and label property
  idsToTags(ids) {
    if (ids && ids.length) {
      return ids.map(id => this.props.allTags.find(t => t.id === id));
    } else {
      return [];
    }
  }

  tagsToIds(tags) {
    if (tags && tags.length) {
      return tags.map(t => t.id);
    } else {
      return [];
    }
  }

  componentWillReceiveProps(props) {
    if (!this.props.option && props.option) {
      this.setState({
        ...props.option
      });
    }
  }

  getCriteria(question) {
    return (
      this.state.criteria[question.id] ||
      (this.props.option ? (question.domainLogic).criteria[this.props.option.id]: false) ||
      []
    );
  }

  handleCriteriaDialogSave(criteria, questionId) {
    const newCriteria = {...this.state.criteria};
    // Setting to an empty array enables the reducer to delete the criteria once saved
    newCriteria[questionId] = criteria || [];
    this.setState({ criteria: newCriteria, criteriaDialogOpen: false });
  }

  getCriteriaQuestions() {
    var questionClicked = this.props.questions.find(
        q => this.state.criteriaDialogOpen === q.id
      )
    if(questionClicked.answerType === "normal"){
      return [questionClicked];
    } else {
      return this.props.questions.filter((q) => questionClicked.satisfiedBy.includes(q.id));
    }
  }

  render() {
    let header = this.props.option ? "Update Option" : "New Option";
    let tabsInitialSelectedIndex = 0;
    let tabContainerBgStyle = { backgroundColor: "#efefef", color: "black" };
    let toolbarConfig = {
      image: {
        uploadCallback: this.props.onUpload
      },
      link: {defaultTargetOption: '_blank'}
    };
    let tagOptions = this.props.allTags
      .filter(t => t.section === this.state.section)
      .map(tag => {
        return { value: tag.id, label: tag.label };
      });
    let outputCatTitle = this.state.section === "assessment" ? "Output Category" : "Category";


    const shouldShowCriteriaIndicator = questions => {
      for (const question of questions) {
        if (this.getCriteria(question).length > 0) {
          return true;
        }
      }
      return false;
    };

    return (
      <Card style={adminCardStyle}>
        <CardHeader title={header} />
        <CardText>
          <div style={{ float: "left", marginRight: 20 }}>
            <SelectField
              placeholder="Section"
              floatingLabelText="Section"
              ref="section"
              value={this.state.section}
              onChange={this.handleSectionChange.bind(this)}
            >
              <MenuItem value="monitoring" primaryText="Data Collection" />
              <MenuItem value="assessment" primaryText="Assessment" />
              <MenuItem value="controlRules" primaryText="Management Measures" />
              <MenuItem value="enforcement" primaryText="Enforcement" />
            </SelectField>
          </div>
          <div style={{ float: "left" }}>
            <SelectField
              errorText={this.state.categoryErrorText}
              floatingLabelText={outputCatTitle}
              style={{ width: 450 }}
              ref="category"
              value={this.state.category}
              onChange={this.handleCategoryChange.bind(this)}
            >
              {this.props.categories
                .filter(c => c.type !== "question" && !c.inputCategory)
                .map(c => (
                  <MenuItem key={c.id} value={c.id} primaryText={c.title} />
                ))}
            </SelectField>
            {
              this.state.section === "assessment" ?
                <div>
                  <SelectField
                    floatingLabelText="Assessment Category (Assessment Only)"
                    style={{ width: 360, marginRight:20 }}
                    ref="inputCategory"
                    value={this.state.inputCategory}
                    onChange={this.handleInputCategoryChange.bind(this)}
                    errorText={this.state.inputCatErrorText}
                  >
                    {this.props.categories
                      .filter(c => c.type !== "question" && c.inputCategory)
                      .map(c => (
                        <MenuItem key={c.id} value={c.id} primaryText={c.title} />
                      ))}
                  </SelectField>
                  <SelectField
                    errorText={this.state.assessmentTierErrorText}
                    floatingLabelText="Tier (Assessment Only)"
                    style={{width: 360}}
                    ref="assessmentTier"
                    value={this.state.assessmentTier}
                    onChange={this.handleAssessmentTierChange.bind(this)}
                  >
                    {
                      assessmentTiers.map((tier) => <MenuItem key={tier.id} value={tier.id} primaryText={tier.title} />)
                    }
                  </SelectField>
                </div>: null
            }
          </div>
          <br style={{ clear: "both" }} />
          <TextField
            style={{ width: "100%" }}
            ref="title"
            floatingLabelText="Option Title"
            // defaultValue={this.state.title}
            value={this.state.title}
            errorText={this.state.titleErrorText}
            onChange={this.checkTitle}
          />
          <br />
          <div>
            <CardHeader subtitle="Tags" />
            <Select
              noOptionsMessage={() =>
                "No tags in project. Tags can be created from their dedicated admin area"
              }
              name="tags"
              value={this.state.tags}
              options={tagOptions}
              onChange={this.handleTagsChange}
              isMulti={true}
            />
          </div>
          <br />
        </CardText>

        <Card style={{ width: "90%", margin: "40px auto" }} zDepth={1}>
          <CardHeader title="Reference Content" />
          <Tabs>
            <Tab label="Description">
              <Editor
                toolbar={toolbarConfig}
                editorStyle={editorStyle}
                toolbarStyle={toolbarStyle}
                editorState={this.state.descriptionState}
                onEditorStateChange={this.handleDescriptionChange}
              />
            </Tab>
            <Tab label="Assessment Output">
              <Editor
                toolbar={toolbarConfig}
                editorStyle={editorStyle}
                toolbarStyle={toolbarStyle}
                editorState={this.state.assessmentOutputState}
                onEditorStateChange={this.handleAssessmentOutputChange}
              />
            </Tab>
            <Tab label="Contacts">
              <Editor
                toolbar={toolbarConfig}
                editorStyle={editorStyle}
                toolbarStyle={toolbarStyle}
                editorState={this.state.contactsState}
                onEditorStateChange={this.handleContactsChange}
              />
            </Tab>
            <Tab label="References">
              <Editor
                toolbar={toolbarConfig}
                editorStyle={editorStyle}
                toolbarStyle={toolbarStyle}
                editorState={this.state.referencesState}
                onEditorStateChange={this.handleReferencesChange}
              />
            </Tab>
          </Tabs>
        </Card>
        <Card style={{ width: "90%", margin: "40px auto" }} zDepth={1}>
          <CardHeader title="Option Domain Logic" />
          <Tabs
            tabItemContainerStyle={{ backgroundColor: "white", color: "black" }}
            initialSelectedIndex={tabsInitialSelectedIndex}
          >
            <Tab style={tabContainerBgStyle} label="Criteria">
              <CardText>
                Please be sure to select <i>all</i> answers that can meet a
                criteria.
              </CardText>
              <CategorizedItemList
                showIndicator={shouldShowCriteriaIndicator}
                expandable={true}
                categories={this.props.questionCategories}
                items={this.props.questions}
              >
                {question => {
                  const criteria = this.getCriteria(question);
                  return (
                    <ListItem
                      key={question.id}
                      onClick={() =>
                        this.setState({ criteriaDialogOpen: question.id })
                      }
                      style={
                        criteria.length
                          ? {
                              // textDecoration: "underline",
                              fontWeight: 500
                              // textDecorationColor: "#34a4ef"
                            }
                          : { color: "grey" }
                      }
                      primaryText={
                        <span>
                          {question.title.replace(/<.*?>/gm, '')}{" "}
                          <span
                            style={{
                              display: criteria.length ? "inline" : "none",
                              marginLeft: 10,
                              textShadow: "1px 1px 1px #00000069",
                              backgroundColor: "#6db2d9",
                              color: "white",
                              padding: "4px 6px",
                              borderRadius: 3,
                              lineHeight: "32px",
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {criteria.length
                              ? `${criteria.length} criteria answers`
                              : ""}
                          </span>
                        </span>
                      }
                    />
                  );
                }}
              </CategorizedItemList>
              {this.state.criteriaDialogOpen ? (
                <CriteriaDialog
                  open={true}
                  criteria={this.getCriteria(this.props.questions.find((q) => q.id === this.state.criteriaDialogOpen))}
                  questions={this.getCriteriaQuestions()}
                  onSave={criteria =>
                    this.handleCriteriaDialogSave(
                      criteria,
                      this.state.criteriaDialogOpen
                    )
                  }
                  onClose={() =>
                    this.setState({ criteriaDialogOpen: false })
                  }
                />
              ) : (
                ""
              )}
            </Tab>
            <Tab style={tabContainerBgStyle} label="Caveats">
              <CategorizedQuestionList
                categories={this.props.questionCategories}
                questions={this.props.questions.filter((q) => q.answerType === "normal")}
                ref="caveatQuestionList"
              >
                <CaveatListEditor
                  optionID={this.props.option ? this.props.option.id : null}
                />
              </CategorizedQuestionList>
            </Tab>
          </Tabs>
        </Card>
        <AdditionalCaveatsEditor
          ref="additionalCaveats"
          caveats={this.props.option ? this.props.option.additionalCaveats : []}
        />
        <CardText>
          <CardActions style={{ textAlign: "right" }}>
            {this.props.option ? (
              <IconButton
                style={{ top: 8 }}
                tooltip="Delete Option"
                onClick={this.delete}
              >
                <DeleteIcon color="red" />
              </IconButton>
            ) : (
              ""
            )}
            <FlatButton onClick={this.cancel.bind(this)} label="cancel" />
            <RaisedButton
              onClick={this.submit.bind(this)}
              primary={true}
              label="Save"
            />
          </CardActions>
        </CardText>
      </Card>
    );
  }

  handleTagsChange = v => {
    this.setState({ tags: v || [] });
  };

  handleDescriptionChange(v) {
    this.setState({ descriptionState: v });
  }

  handleAssessmentOutputChange(value) {
    this.setState({ assessmentOutputState: value });
  }

  handleContactsChange(value) {
    this.setState({ contactsState: value });
  }

  handleReferencesChange(value) {
    this.setState({ referencesState: value });
  }

  showCategoryIndicatorTest(category, questions) {
    return !!questions.find(q => {
      var criteria = q.domainLogic.criteria[this.props.option.id];
      return criteria && criteria.length;
    });
  }

  handleSectionChange(event, index, value) {
    this.setState({ section: value });
  }

  handleCategoryChange(event, index, value) {
    this.setState({ category: value });
    this.checkCategory(value);
  }

  handleInputCategoryChange(event, index, value) {
    this.setState({ inputCategory: value });
    this.checkInputCategory(value);
  }

  handleAssessmentTierChange(event, index, value){
    this.setState({assessmentTier: value});
    this.checkAssessmentTier(value);
  }

  checkCategory(value) {
    if (this.state.category || value) {
      this.setState({ categoryErrorText: "" });
      return true;
    } else {
      this.setState({ categoryErrorText: "Category is required" });
      return false;
    }
  }

  checkInputCategory(value) {
  //inputCategory is in assessment only, if in other section always pass check
    if(this.state.section === "assessment"){
      if (this.state.inputCategory || value) {
        this.setState({inputCatErrorText: ""});
        return true;
      } else {
        this.setState({inputCatErrorText: "Input Category is required"});
        return false;
      }
    } else {
      return true;
    }
  }

  checkAssessmentTier(value) {
    //assessmentTier is in assessment only, if in other section always pass check
    if(this.state.section === "assessment"){
      if (this.state.assessmentTier || value) {
        this.setState({assessmentTierErrorText: ""});
        return true;
      } else {
        this.setState({assessmentTierErrorText: "Tier is required"});
        return false;
      }
    } else {
      return true;
    }
  }

  checkTitle(el, title) {
    if (title && title.length > 0) {
      this.setState({
        titleErrorText: "",
        title
      });
      return true;
    } else {
      this.setState({
        titleErrorText: "Title is required",
        title
      });
      return false;
    }
  }

  validateFields(){
    //validate each to trigger error text for all that are missing
    let titleValidated = this.checkTitle(null, this.refs.title.getValue());
    let categoryValidated = this.checkCategory(this.state.category);
    let inputCatValidated = this.checkInputCategory(this.state.inputCategory);
    let assessmentTierValidated = this.checkAssessmentTier(this.state.assessmentTier);

    if(titleValidated && categoryValidated &&  inputCatValidated && assessmentTierValidated){
      return true;
    } else {
      return false;
    }
  }

  submit() {
    if (this.validateFields()) {
      let attrs = {
        title: this.refs.title.getValue(),
        description: toHtml(this.state.descriptionState),
        assessmentOutput: toHtml(this.state.assessmentOutputState),
        contacts: toHtml(this.state.contactsState),
        references: toHtml(this.state.referencesState),
        section: this.state.section,
        category: this.state.category,
        inputCategory: this.state.inputCategory,
        assessmentTier: this.state.assessmentTier,
        additionalCaveats: this.refs.additionalCaveats.getValue(),
        tags: this.tagsToIds(this.state.tags)
      };
      // return;
      if (this.props.option) {
        this.props.onUpdate(
          this.props.option.id,
          attrs,
          this.getUpdatedDomainLogic()
        );
      } else {
        this.props.onCreate(attrs, this.getUpdatedDomainLogic());
      }
      this.props.router.push("/admin/options");
    } else {
      alert("Required Fields Missing.")
    }
  }

  getUpdatedDomainLogic() {
    let domainLogic = {};
    let optionID = this.props.option ? this.props.option.id : "new";
    if (Object.keys(this.state.criteria).length) {
      domainLogic["criteria"] = {};
      for (var questionID in this.state.criteria) {
        domainLogic["criteria"][questionID] = domainLogic["criteria"][questionID] || {};
        domainLogic["criteria"][questionID][optionID] = this.state.criteria[questionID];
      }
    }
    if (this.refs.caveatQuestionList) {
      domainLogic[
        "caveats"
      ] = this.refs.caveatQuestionList.getChildren().reduce((logic, editor) => {
        // logic[questionID] = {optionID: editor.getValue()}
        if (editor.hasChanged()) {
          logic[editor.props.id] = { [optionID]: editor.getValue() };
        }
        return logic;
      }, {});
    }
    return domainLogic;
  }

  delete() {
    if (global.confirm("Are you sure you want to delete this option?")) {
      this.props.onDelete(this.props.option.id);
      this.goBack();
    }
  }

  cancel() {
    this.goBack();
  }

  goBack() {
    this.props.router.push("/admin/options");
  }
}

const mapStateToProps = (state, ownProps) => {
  let id = parseInt(ownProps.routeParams.id);
  return {
    option: state.options.find(t => t.id === id),
    categories: state.categories.filter(
      c => c.type === "option" || c.type === "target"
    ),
    questionCategories: state.categories.filter(c => c.type === "question"),
    questions: state.questions,
    allTags: state.tags,
    domainLogic: state
  };
};

const mapDispatchToProps = (dispatch, getStore) => {
  return {
    onCreate: (props, d) => dispatch(createOption(props, d)),
    onUpdate: (id, props, d) => dispatch(updateOption(id, props, d)),
    onDelete: id => dispatch(deleteOption(id)),
    onUpload: file => dispatch(uploadImage(file))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OptionForm));
